import { Link } from '@tanstack/react-router';

const Logo = () => {
  return (
    <Link
      to="/dashboard"
      className="flex h-[85px] items-center overflow-hidden pt-5 md:pt-0"
      style={{ width: '100%' }}
    >
      <div className="relative w-[125px]" style={{ margin: 'auto' }}>
        <img src="/images/logos/logo.png" alt="logo" />
      </div>
    </Link>
  );
};

export default Logo;
